export type ConsoleEntry = {
  at: string;
  level: 'warn' | 'error';
  message: string;
};

const RING_CAPACITY = 30;
const ring: ConsoleEntry[] = [];

export function getConsoleLogSnapshot(): ConsoleEntry[] {
  return ring.slice();
}

let installed = false;

export function installConsolePatches() {
  if (installed) return;
  installed = true;

  patch('error');
  patch('warn');
}

function patch(level: 'error' | 'warn') {
  const original = console[level].bind(console);
  console[level] = (...args: unknown[]) => {
    try {
      ring.push({
        at: new Date().toISOString(),
        level,
        message: args.map(stringify).join(' ').slice(0, 1000),
      });
      while (ring.length > RING_CAPACITY) ring.shift();
    } catch {
    }
    original(...args);
  };
}

function stringify(v: unknown): string {
  if (v === null || v === undefined) return String(v);
  if (typeof v === 'string') return v;
  if (v instanceof Error) return `${v.name}: ${v.message}`;
  try {
    return JSON.stringify(v);
  } catch {
    return Object.prototype.toString.call(v);
  }
}
